<template>
  <v-card
    flat
    rounded="lg"
    color="white"
    width="300"
    class="mx-auto"
  >
    <v-row align="start" justify="center" class="text-center fill-height py-5">
      <v-col>
        <h3 class="font-weight">{{ plan.name }}</h3>

        <h1 class="price my-3">
          <span class="peso primary--text" v-html="MIXIN_PESO_SIGN"></span>
          <span class="primary--text">{{ plan.amount | numFormat }}</span>
          <span class="label">{{ plan.amount | numFormat('.00') }} / YR</span>
        </h1>

        <div class="font-weight-bold">*VAT exclusive</div>
        <div class="font-weight-bold">for 1 year</div>

        <v-btn
          tile
          depressed
          large
          color="#9faebc"
          dark
          class="my-4"
          @click="getSelectedPlan(plan)"
        >
          Get my plan now!
        </v-btn>

        <div class="font-weight-light pre-wrap px-5 description mt-5">{{ plan.description }}</div>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import { RESELLER_EVENT_BUS } from "@/views/reseller/js/ResellerEventBus";
  export default {
    name: 'ResellerPlanCard',

    props: {
      plan: { type: Object }
    },
    methods: {
      getSelectedPlan(plan) {
        RESELLER_EVENT_BUS.selectedPlan = plan;
        this.$router.push(`/shop/reseller/checkout/${this.$route.params.slug}`);
      }
    }
  }
</script>

<style lang="scss" scoped>
  .peso {
    font-family: Arial;
  }

  .price {
    letter-spacing: 0.5px;
  }

  .label {
    font-size: 14px;
  }

  .description {
    font-size: 14px;
    line-height: 200%;
  }
</style>